<template>
  <component-wrapper
    ref="wrapperRef"
    class="square-lovin-fi"
  >
    <grid-container-fi>
      <div
        class="square-lovin-fi__container"
        :data-sq-container="fields.containerId?.value"
        :data-sq-stream="fields.streamId?.value"
        :data-sq-sub="fields.subId?.value"
        :data-sq-template="fields.template?.value"
        :data-sq-lang="fields.language?.value"
        data-sq-import-on-load="outline"
      />
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFields } from '@/composables/fields';

defineOptions({
  name: 'SquareLovinFi',
});

const fields = useFields('SquareLovinFiFields');
const wrapperRef = ref<InstanceType<typeof ComponentWrapper> | null>(null);
let observer: IntersectionObserver | null = null;

const load = () => {
  if (!document.getElementById('square-lovin')) {
    const script = document.createElement('script');
    script.type = 'module';
    script.id = 'square-lovin';
    script.src = 'https://delivery-assets.squarelovin.com/sdk/squarelovin.min.js';
    document.head.appendChild(script);
  }
};

onMounted(() => {
  const el = wrapperRef.value?.$el as HTMLElement | undefined;
  if (!el) {
    load();
    return;
  }

  const margin = fields.intersectionOffset?.value || '200';
  observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        load();
        observer?.disconnect();
        observer = null;
      }
    },
    { rootMargin: `${margin}px` },
  );

  observer.observe(el);
});

onUnmounted(() => {
  observer?.disconnect();
});
</script>

<style scoped src="./square-lovin-fi" />
